/* AARK General Trading — aark-main.js */

document.addEventListener('DOMContentLoaded', function () {

  /* ── Mobile nav toggle ── */
  const hamburger = document.querySelector('.nav-hamburger');
  const mobileNav = document.querySelector('.mobile-nav');
  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', function () {
      mobileNav.classList.toggle('is-open');
      hamburger.setAttribute('aria-expanded', mobileNav.classList.contains('is-open'));
    });
    mobileNav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        mobileNav.classList.remove('is-open');
      });
    });
  }

  /* ── Smooth scroll for anchor links ── */
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        var offset = 70;
        var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    });
  });

  /* ── Enquiry form feedback ── */
  var formBtn = document.querySelector('.js-enquiry-btn');
  if (formBtn) {
    formBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var form = document.querySelector('.js-enquiry-form');
      var inputs = form ? form.querySelectorAll('[required]') : [];
      var valid = true;
      inputs.forEach(function (input) {
        if (!input.value.trim()) { input.style.borderColor = '#e05050'; valid = false; }
        else { input.style.borderColor = ''; }
      });
      if (!valid) return;
      formBtn.textContent = 'Enquiry Sent ✓';
      formBtn.style.background = 'var(--gold)';
      formBtn.style.color = 'var(--charcoal)';
      formBtn.disabled = true;
    });
  }

  /* ── Sticky header scroll class ── */
  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > 30);
    });
  }

});
